import type ProfileStore from "../../../../stores/ProfileStore";
import type {ColSpec} from "../../../../components/table/MithraTableHeadColumns";
import {getPpvColumnOptions} from "./PpvConfig";
import {authStore} from "../../../../stores/init.ts";

export function getPpvSubTableColumns(p: ProfileStore): ColSpec[] {
    const enabledColumns = getPpvColumnOptions(p);
    const arr: (ColSpec | null)[] = [
        {cls: 'col-p_name', txt: p.partDataName, align: 'center'},
        {cls: 'col-p_description', txt: 'Description'},
        {cls: 'col-n_parts', txt: 'Transaction count', align: 'center'},
        {cls: 'col-s_name', txt: p.supplierDataName, align: 'center'},
        enabledColumns.includes('s_country')
            ? {cls: 'col-s_country', txt: 'Supplier location', align: 'center'} : null,
        enabledColumns.includes('cc_description')
            ? {cls: 'col-cc_description', txt: p.ccDescriptionDataName, align: 'center'} : null,
        enabledColumns.includes('p_incoterms')
            ? {cls: 'col-p_incoterms', txt: 'Incoterms', align: 'center'} : null,
        enabledColumns.includes('p_incoterms_location')
            ? {cls: 'col-p_incoterms_location', txt: 'Incoterms Location', align: 'center'} : null,
        enabledColumns.includes('business_unit')
            ? {cls: 'col-business_unit', txt: 'Business Unit', align: 'center'} : null,
        {cls: 'col-p_quantity', txt: 'Quantity', align: 'center'},
        {cls: 'col-p_spend', txt: 'Amount', align: 'center'},
        {cls: '', txt: 'Latest Purchase', align: 'center'},
        {cls: 'col-combined_unit_cost', txt: 'Avg. unit cost', align: 'center'},
        {cls: 'col-ppv_delta', txt: 'Variance cost', align: 'center'},
        {cls: 'col-ppv_delta_perc', txt: 'PPV delta %', align: 'center'},
        {cls: 'col-ppv_opportunity', txt: 'PPV opportunity', align: 'center'},
        authStore.hasEditPermission ? {cls: 'col-button', txt: '', align: 'center'} : null,
    ];
    return arr.filter(c => c) as ColSpec[];
}

export function getPpvTableColumns(p: ProfileStore, hasActiveFilter: boolean): ColSpec[] {
    const arr: (ColSpec | null)[] = [
        {cls: 'col-dropdown', txt: '', align: 'center'},
        {cls: 'col-group_key', txt: p.groupKeyDataName},
        {cls: 'col-variance_types', txt: 'Variance Types', align: 'center'},
        {
            cls: 'col-total_variance_cost',
            txt: hasActiveFilter ? 'Selected PPV Opportunity' : 'Total PPV Opportunity',
            align: 'center'
        },
        {cls: 'col-notes', txt: 'Notes', width: 300},
        {cls: 'col-button', txt: '', width: 150},
    ];

    return arr.filter(c => c) as ColSpec[];
}
